import crud from '@/crud/form/form'
import resources from '../../resources'

import computed from './computed'
import methods from './methods'
import data from './data'
import mounted from './mounted'
import validations from './validations'

export default {
  data,
  computed,
  methods,
  mounted,
  validations,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/form/resources/index.js